import { Component, Input, OnInit } from '@angular/core';
import { StepDescription } from '../../models/intefaces/step-description';

const empty = new StepDescription('', '', '');

@Component({
  selector: 'app-step-description',
  templateUrl: './step-description.component.html',
  styleUrls: ['./step-description.component.scss'],
})
export class StepDescriptionComponent implements OnInit {
  @Input()
  public description: StepDescription = empty;

  constructor() {}

  ngOnInit(): void {}
}
